import React, { Component } from 'react';
import { getReceipts } from '../Networking/APIClient';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';

// The styles must be defined on the top with the current approach, otherwise, they have no effect.
const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#808080',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        padding: 5,
        margin: 5
    },

}))(TableCell);

// The first cell looks better with a bit more padding
const CustomFirstTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#808080',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        marginRight: 10,
        paddingRight: 10
    },

}))(TableCell);

const styles = theme => ({
    root: {
        overflowX: 'auto',
        maxWidth: '1000px',
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    noReceiptsText: {
        margin: 10,
    }
});

let t;
let self;

class Receipts extends Component {
    constructor(props) {
        super(props);
        self = this;
        t = props.getTranslation;

        this.updateReceipts = this.updateReceipts.bind(this);
        this.formatDate = this.formatDate.bind(this);

        this.state = {
            receipts: null
        }
    }

    componentDidMount() {
        self.updateReceipts()
    }

    // Download receipts for this customer from the API and show a progress bar.
    updateReceipts() {
        const onOk = function onOk(data) {
            self.setState({
                receipts: data.receipts,
            })
            self.props.setLoading(false)
        };

        const onError = function onError() {
            console.log("Error downloading receipts")
            self.props.setLoading(false)
        };

        self.props.setLoading(true)
        getReceipts(self.props.credentials, onOk, onError)
    }

    // Remove time from the date string. We only need the date.
    formatDate(dateString) {
        const date = new Date(dateString)
        const options = { weekday: undefined, year: '2-digit', month: '2-digit', day: '2-digit' }
        if (date) {
            return date.toLocaleDateString(undefined, options)
        }
        return 'N/A'
    }

    render() {
        const { classes } = this.props;
        const receipts = this.state.receipts

        // If we are loading the receipts, a loading bar is shown in the Main component.
        // In that case, this component does not need to render anything.
        if (!receipts || this.props.isLoading) {
            return null
        }

        // If we have no receipts, tell the user.
        if (receipts.length === 0) {
            return <Typography className={classes.noReceiptsText} variant="title">{t('no_receipts_available_message')}</Typography>
        }

        // Return a table showing all the receipts of this customer.
        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableBody>
                        <TableRow className={classes.row}>
                            <CustomFirstTableCell ><b>{t('value_code')}</b></CustomFirstTableCell>
                            <CustomTableCell ><b>{t('type')}</b></CustomTableCell>
                            <CustomTableCell ><b>{t('price')}</b></CustomTableCell>
                            <CustomTableCell ><b>{t('date')}</b></CustomTableCell>
                            <CustomTableCell ><b>Link</b></CustomTableCell>
                        </TableRow>
                        {receipts.map((receipt) => {
                            return (<TableRow className={classes.row} key={receipt.date}>
                                <CustomFirstTableCell >{receipt.value_code}</CustomFirstTableCell>
                                <CustomTableCell >{receipt.subscription_type}</CustomTableCell>
                                <CustomTableCell >{receipt.price}</CustomTableCell>
                                <CustomTableCell >{self.formatDate(receipt.date)}</CustomTableCell>
                                {receipt.url ? <CustomTableCell ><a href={receipt.url} target="_blank">{t('download')}</a></CustomTableCell> : <CustomTableCell >N/A</CustomTableCell>}
                            </TableRow>)
                        })}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

export default withStyles(styles)(Receipts);


// WEBPACK FOOTER //
// ./src/Pages/Receipts.js